// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/sweetalert2/dist/sweetalert2.css
// module id = 235
// module chunks = 1